import { trans } from '@spotahome/soyuz/client';

const CouplesNotAllowed = () => (
  <li>{trans('property_show.instant_booking_modal.couples')}</li>
);

export default CouplesNotAllowed;
